/**
 * One-click point prices shown before a request is sent
 * (SPEC-ONECLICK-BILLING-001 REQ-OCB-003, REQ-OCB-010). Display only: the
 * server holds and settles the actual points.
 */

/** Points per generated sub-question; a request for N questions holds 4N. */
export const ONECLICK_POINTS_PER_QUESTION = 4;
/**
 * Hold for an unspecified question count: 4 × the 30-question unspecified cap
 * (ONECLICK_UNSPECIFIED_QUESTION_CAP), mirroring the server generation_hold_amount.
 */
export const ONECLICK_UNSPECIFIED_HOLD_POINTS = 120;
/** Points per OCR page (one image = one page). */
export const ONECLICK_OCR_POINTS_PER_PAGE = 2;
/**
 * Points per passage sent with the "지문을 변형하여 출제" option: held with the
 * request, charged only when questions are charged.
 */
export const ONECLICK_TRANSFORM_POINTS_PER_PASSAGE = 1;

/** REQ-OCB-020 (b), REQ-OCV-020 (b): shown when no question count is given (the request holds 120 points). */
export const ONECLICK_UNSPECIFIED_COUNT_WARNING =
  '문항 수를 지정하지 않으면 최종 출제된 문제 수에 따라 문제당 4포인트가 청구됩니다. (최대 120포인트)';

/** Expected points of a generation request with an optional question count and transformed passages. */
export function oneclickGenerationPoints(questionCount: number | null | undefined, transformCount = 0): number {
  const questionPoints =
    questionCount != null ? ONECLICK_POINTS_PER_QUESTION * questionCount : ONECLICK_UNSPECIFIED_HOLD_POINTS;
  return questionPoints + ONECLICK_TRANSFORM_POINTS_PER_PASSAGE * transformCount;
}

/** The unspecified-count warning with the maximum including the transform points. */
export function oneclickUnspecifiedCountWarning(transformCount: number): string {
  if (transformCount <= 0) return ONECLICK_UNSPECIFIED_COUNT_WARNING;
  return ONECLICK_UNSPECIFIED_COUNT_WARNING.replace(
    `(최대 ${ONECLICK_UNSPECIFIED_HOLD_POINTS}포인트)`,
    `(최대 ${oneclickGenerationPoints(null, transformCount)}포인트)`
  );
}

/** Dialog line for the transformed passages, or null when there are none. */
export function oneclickTransformNotice(transformCount: number): string | null {
  if (transformCount <= 0) return null;
  return `지문 변형 ${transformCount}개: 지문당 ${ONECLICK_TRANSFORM_POINTS_PER_PASSAGE}포인트 추가 (출제된 문제가 있을 때만 청구)`;
}
